export default __webpack_public_path__ + "static/img-6-10c5f8e9edc0dcdbfd213ca12853e1e3.png";